import {REJECTED_QC_LOADED} from "./ActionType";

export default function rejectedQCReducer(state = [], action) {
  const {type, payload} = action;

  switch (type) {
    case REJECTED_QC_LOADED:
      return (state = payload);

    default:
      return state;
  }
}
